import { toValue as n } from "./novoui-vuejs826.js";
import { tryOnScopeDispose as m } from "./novoui-vuejs826.js";
import "vue";
function p(e) {
  var r;
  const o = n(e);
  return (r = o == null ? void 0 : o.$el) != null ? r : o;
}
export {
  n as toValue,
  m as tryOnScopeDispose,
  p as unrefElement
};
